import { Grid, List, Tabs } from '@pankod/refine-antd';
import { ImportCategories } from 'pages/categories/import';
import { ImportClients } from 'pages/clients';
import { ProductImport } from 'pages/products';
import { ImportSuppliers } from 'pages/suppliers';
import { ImportTags } from 'pages/tags';
import { ImportWarehouses } from 'pages/warehouses';

export const ImportMasterPage: React.FC = () => {
  const breakpoint = Grid.useBreakpoint();

  return (
    <List title="Import Data">
      <Tabs defaultActiveKey="clients" tabBarStyle={{ paddingLeft: breakpoint.md ? 0 : 40 }}>
        <Tabs.TabPane tab="Clients" key="clients">
          <ImportClients redirection={false} />
        </Tabs.TabPane>

        <Tabs.TabPane tab="Suppliers" key="suppliers">
          <ImportSuppliers redirection={false} />
        </Tabs.TabPane>

        <Tabs.TabPane tab="Warehouse" key="warehouse">
          <ImportWarehouses redirection={false} />
        </Tabs.TabPane>

        <Tabs.TabPane tab="Tags" key="tags">
          <ImportTags redirection={false} />
        </Tabs.TabPane>

        <Tabs.TabPane tab="Categories" key="categories">
          <ImportCategories redirection={false} />
        </Tabs.TabPane>

        <Tabs.TabPane tab="Products" key="products">
          <ProductImport redirection={false} />
        </Tabs.TabPane>
      </Tabs>
    </List>
  );
};
